import { render, staticRenderFns } from "./reservationComponent.vue?vue&type=template&id=2d9d9f76&"
import script from "./reservationComponent.vue?vue&type=script&lang=js&"
export * from "./reservationComponent.vue?vue&type=script&lang=js&"
import style0 from "./reservationComponent.vue?vue&type=style&index=0&id=2d9d9f76&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports